// @ts-nocheck
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import ProductShipsFrom, { ProductShipsFromPresentationProps } from "@store/Library/Components/ProductShipsFrom";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import React, { FC } from "react";
import { css } from "styled-components";

export interface ProductDetailsShipsFromProps extends WidgetProps {}

export interface ProductDetailsShipsFromStyles {
    productShipsFrom?: ProductShipsFromPresentationProps;
}

export const productDetailsAdditionInfosStyles: ProductDetailsShipsFromStyles = {
    productShipsFrom: {
        extendedStyles: {
            shipFromWrapper: {
                css: css`
                    margin-bottom: ${pxToRem(8)};
                `,
            },
        },
    },
};

const styles = productDetailsAdditionInfosStyles;

const ProductDetailsShipsFrom: FC<ProductDetailsShipsFromProps> = () => {
    return <ProductShipsFrom {...styles.productShipsFrom} />;
};

const widgetModule: WidgetModule = {
    component: ProductDetailsShipsFrom,
    definition: {
        group: "Product Details",
        displayName: "Product Details Additionnal Informations",
        allowedContexts: ["ProductDetailsPage"],
    },
};

export default widgetModule;
